// src/useHttp/index.tsx
import axios from "axios";
import { useState } from "react";

// src/useConfig/index.tsx
import React, {
  useContext
} from "react";
import { jsx } from "react/jsx-runtime";
var ConfigContext = React.createContext({});
var ConfigProvider = ({
  children,
  config = {}
}) => /* @__PURE__ */ jsx(ConfigContext.Provider, {
  value: config,
  children
});
var useConfig = () => useContext(ConfigContext);

// src/useHttp/index.tsx
var useHttp = ({
  url,
  method = "get",
  data,
  headers
}) => {
  const { token, apiBaseUrl, httpStrategy } = useConfig();
  const [state, setState] = useState({
    loading: false,
    error: null,
    data: null,
    code: null
  });
  const fetchData = async (params) => {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    try {
      setState({
        ...state,
        loading: true,
        error: null,
        code: 0
      });
      const response = await axios({
        url: `${apiBaseUrl}${url}`,
        method,
        ...method === "get" ? {
          params: {
            ...data,
            ...params
          }
        } : {
          data
        },
        headers: {
          ...headers,
          Authorization: token ? `Bearer ${token}` : "",
          Lang: window.localStorage.getItem("d5-language") || "en"
        }
      });
      setState({
        loading: false,
        error: null,
        code: 200,
        data: response.data
      });
    } catch (error) {
      const errorMessage = ((_c = (_b = (_a = error == null ? void 0 : error.response) == null ? void 0 : _a.data) == null ? void 0 : _b.meta) == null ? void 0 : _c.message) || ((_e = (_d = error == null ? void 0 : error.response) == null ? void 0 : _d.data) == null ? void 0 : _e.message) || (error == null ? void 0 : error.message) || "An error occurred";
      const statusCode = ((_f = error == null ? void 0 : error.response) == null ? void 0 : _f.status) || 500;
      setState({
        loading: false,
        error: errorMessage,
        code: statusCode,
        data: null
      });
      if (((_g = error == null ? void 0 : error.response) == null ? void 0 : _g.status) && httpStrategy[error.response.status]) {
        (_h = httpStrategy[error.response.status]) == null ? void 0 : _h.call(httpStrategy);
      }
    }
  };
  return {
    ...state,
    fetchData
  };
};

// src/useStorage/index.tsx
import {
  useState as useState2,
  useEffect
} from "react";
var parseJSON = (value) => {
  try {
    return value === "undefined" ? void 0 : parseJSON(value != null ? value : "");
  } catch {
    console.warn("parsing error on", {
      value
    });
    return void 0;
  }
};
var useStorage = (key, defaultValue, storageType) => {
  if (!key.startsWith("d5-")) {
    throw new Error('storage key should start with "d5-"');
  }
  const [value, setValue] = useState2(defaultValue);
  const storage = storageType === "sessionStorage" ? window.sessionStorage : window.localStorage;
  useEffect(() => {
    try {
      const value2 = storage.getItem(key);
      if (value2) {
        setValue(parseJSON(value2));
      } else {
        storage.setItem(key, JSON.stringify(value2));
      }
    } catch (error) {
      setValue(parseJSON(value));
      if (error instanceof Error)
        console.error(error.message);
    }
  }, []);
  useEffect(() => {
    try {
      storage.setItem(key, JSON.stringify(value));
    } catch (error) {
      if (error instanceof Error)
        console.error(error.message);
    }
  }, [value]);
  const removeValue = () => {
    try {
      storage.removeItem(key);
    } catch (error) {
      if (error instanceof Error)
        console.error(error.message);
    }
  };
  return [value, setValue, removeValue];
};
var useLocalStorage = (key, defaultValue) => useStorage(key, defaultValue, "localStorage");
var useSessionStorage = (key, defaultValue) => useStorage(key, defaultValue, "sessionStorage");
export {
  ConfigContext,
  ConfigProvider,
  useConfig,
  useHttp,
  useLocalStorage,
  useSessionStorage,
  useStorage
};
